if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    customFieldValidation(){
      let status = true
      const validateFields = document.querySelectorAll("[validate-fields]")

      validateFields.forEach(validateField => {
        const validationType = validateField.dataset.type
        const varidateAreas = validateField.querySelectorAll("[validate-checkbox]")
        if(varidateAreas){
          varidateAreas.forEach(varidateArea => {
            const inputName = varidateArea.dataset.inputname

            if(!inputName) return

            if(!varidateArea.hasAttribute("validate")) return //temp
            
            const validateInputs = varidateArea.querySelectorAll("[name='"+inputName+"']")
            
            if(validateInputs.length == 0 && status == false){
              status = true
            }else{
              const messageAttr = inputName+"-error"
              if(varidateArea.querySelectorAll("[name='"+inputName+"']:checked").length == 0){
                status = false
                const message = `*Please Choose Your ${inputName}.`
                let messageField = document.createElement("p");
                
                if(validateField.querySelector("["+messageAttr+"]")){
                  validateField.querySelector("["+messageAttr+"]").innerText = message
                }else{
                  messageField.classList.add("error")
                  messageField.setAttribute(messageAttr,"")
                  messageField.innerText = message
                  varidateArea.after(messageField)
                }
              }else{
                if(validateField.querySelector("["+messageAttr+"]")){
                  validateField.querySelector("["+messageAttr+"]").remove()
                }
                if(status != false){
                  status = true
                }
              }
            }
          })
        }

        const varidateTextAreas = validateField.querySelectorAll("[validate-textbox]")
        if(varidateTextAreas){
          varidateTextAreas.forEach(varidateTextArea => {
            
            const inputName = varidateTextArea.dataset.inputname
            if(!inputName) return
            const inputContainers = varidateTextArea.querySelectorAll(".text__filed-container")
            let field = 1
            inputContainers.forEach(inputContainer => {
              const validateInput = inputContainer.querySelector("input.custom__field-input")
              const fieldContainer = inputContainer.querySelector(".custom__field")
              const messageAttr = validateInput.id+"-"+"error"

              if(validateInput.value == ""){
                status = false
                const message = `*Please enter your personalized text.`
                let messageField = document.createElement("p");
                
                if(inputContainer.querySelector("["+messageAttr+"]")){
                  inputContainer.querySelector("["+messageAttr+"]").innerText = message
                }else{
                  messageField.classList.add("error")
                  messageField.setAttribute(messageAttr,"")
                  messageField.innerText = message
                  fieldContainer.after(messageField)
                }
              }else{
                if(inputContainer.parentElement.querySelector("["+messageAttr+"]")){
                  inputContainer.parentElement.querySelector("["+messageAttr+"]").remove()
                }
                if(status != false){
                  status = true
                }
              }
              field++;
            })
          })
        }
      })

      console.log(document.querySelector(".text__filed-container .field__input"))
      return status;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      //Custom Field Validation
      if(!this.customFieldValidation()) return
      
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
getCartHtml();
         //   this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
